import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from 'redux/slices/uiSlice';
import CarrierForm from 'components/admin/CarrierForm';
import { createCarrier } from 'services/admin/providerService';

function CreateCarrierScreen() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { currentCarrier } = useSelector(store => store.providers);

    useEffect(() => {
        dispatch(setTitle('Nuevo Carrier'));
        // eslint-disable-next-line
    }, [])

    return (
        <CarrierForm
            title={"Cancelar"}
            goBack={() => {
                navigate(-1);
            }}
            submit={(data) => {
                createCarrier(data).then((result) => {
                    navigate(-1);
                }).catch((e) => {
                    console.log(e);
                });
            }}
        />
    );
}

export default CreateCarrierScreen;